import React from "react";
import Img from "./basic/Img";

let scrollFlag = true;
export default function TimetableSP({ isActive }) {
    const style = () => {
        if (scrollFlag === false) {
            return "active";
        } else if (isActive === false && scrollFlag === true) {
            scrollFlag = false;
            return "active";
        } else {
            return "notActive";
        }
    };
    const showModal = () => {
        document
            .getElementById("modal-wrap")
            .style.setProperty("display", "flex");
        document
            .getElementById("timetable")
            .style.setProperty("display", "flex");
        document
            .getElementById("modal-contents")
            .style.setProperty("display", "none");
        document
            .getElementById("modal-main")
            .style.setProperty("overflow-y", "hidden");
        document
            .getElementById("modal-main")
            .style.setProperty("background", "none");
        document
            .getElementById("modal-main")
            .style.setProperty("box-shadow", "none");
        document.body.style.overflowY = "hidden";
        document
            .getElementById("modal-main-bg")
            .style.setProperty("background", "#82ebff");
        document
            .getElementById("modal-main-bg")
            .style.setProperty("opacity", "1");
    };

    return (
        <div className={`bg_illust-wrap ${style()}`}>
            <a
                rel="noopener noreferrer"
                onClick={() => {
                    showModal();
                    gtag("event", "click", {
                        event_category: "modal",
                        event_label: "timetable",
                    });
                }}
            >
                <Img fileName="bg_timetable_01" />
            </a>
        </div>
    );
}
